/**
 * 生成基础axios对象，并对请求和响应做处理
 * 前后端约定接口返回解构规范
 * {
 *    code:0,
 *    data:"成功",
 *    message:""
 * }
 */
import axios from "axios";
import { message } from "antd";
import { createBrowserHistory } from "history";
import qs from "qs";

const history = createBrowserHistory();

// 创建一个独立的axios实例
const service = axios.create({
  // 设置baseUr地址,如果通过proxy跨域可直接填写base地址
  baseURL: "/api",
  // baseURL: 'http://127.0.0.1:7001/api',
  // 定义统一的请求头部
  headers: {
    // "Content-Type": "application/json;charset=UTF-8",
    // "Content-Type": "application/json;charset=UTF-8",
    // "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
  // 配置请求超时时间
  timeout: 60000,
  // 如果用的JSONP，可以配置此参数带上cookie凭证，如果是代理和CORS不用设置
  //   withCredentials: false,
  //   async: false,
});
// 请求拦截
// service.interceptors.request.use((config) => {
//   // console.log('config', config);
//   return config;
// });
// 返回拦截
service.interceptors.response.use(
  (response) => {
    // 获取接口返回结果
    const res = response.data;
    console.log("接口返回结果:", res);
    if (res.code !== 0) {
      message.error(res.message);
    }
    if (res.code === -2) {
      window.location.href = '/login'
      // history.replace("/login");
    }
    // code为0，直接把结果返回回去，这样前端代码就不用在获取一次data.
    return res;
  },
  (response) => {
    console.log("++++++++++++++++++++++++++ response", response);
  }
);

const request = ({ method, path, params, headers }) => {
  const methodStr = method.toUpperCase();
  if (methodStr === "GET") {
    return service.get(path, {
      headers,
      params,
    });
  }
  if (methodStr === "POST") {
    return service.post(path, params, {
      //   timeout: 10000,
      //   headers: {},
    });
  }
};
export default request;
